export { createVertex, vertex } from './google-vertex-provider-edge';
export type {
  GoogleVertexProviderSettings,
  GoogleVertexProvider,
} from './google-vertex-provider-edge';
